import React from "react";
import { Card, CardBody, Form, FormGroup } from "reactstrap";
import HeaderCard from "../../../../Shared/Components/HeaderCard";

import EntitiesSelector from "./EntitiesSelector";

export default function Entities({ register, errors, reset, setValue }) {
  return (
    <>
      <Card>
        <HeaderCard
          title="Entidades"
          span1="Selecciona los medios o empresas a los que pertenece"
        />
        <CardBody>
          <div id="remote">
            <Form className="theme-form">
              <FormGroup>
                <EntitiesSelector
                  register={register}
                  errors={errors}
                  reset={reset}
                  setValue={setValue}
                />
              </FormGroup>
            </Form>
          </div>
        </CardBody>
      </Card>
    </>
  );
}
